import React from 'react';

export default function Legal() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-24 pb-16 md:pt-32 md:pb-24 px-5 md:px-8 bg-ink min-h-screen text-cream font-body">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-display text-4xl md:text-5xl font-medium tracking-tighter text-cream mb-4">
          TERMS & <span className="italic font-light font-shadows text-olive">CONDITIONS</span>
        </h1>
        <div className="text-[10px] tracking-[0.2em] uppercase text-cream/40 mb-12">
          Last Updated: September 1 2026
        </div>

        <div className="space-y-8 text-cream/70 leading-relaxed text-sm md:text-base">
          <p>
            Welcome to VOW Tattoo & Piercing Studio (“VOW Tattoo Studio”, “we”, “us”, or “our”). By accessing our website, booking an appointment, or using our services, you agree to the following Terms & Conditions.
          </p>

          <div>
            <h2 className="text-olive font-display text-xl mb-2 tracking-tight">Services</h2>
            <p>
              VOW Tattoo Studio provides professional tattooing, piercing, consultation, and related services. Designs, pricing, appointment duration, and availability may vary depending on the requirements of each client.
            </p>
          </div>

          <div>
            <h2 className="text-olive font-display text-xl mb-2 tracking-tight">Appointments & Bookings</h2>
            <p>
              Appointments are subject to availability and confirmation by VOW Tattoo Studio. A booking may require an advance payment/deposit, as communicated at the time of booking. Appointment slots are reserved only after the required booking amount has been received. Clients must provide accurate contact and appointment information.
            </p>
          </div>

          <div>
            <h2 className="text-olive font-display text-xl mb-2 tracking-tight">Tattoo Designs & Custom Work</h2>
            <p>
              Custom tattoo designs are created based on discussions between the client and artist. Minor modifications may be made before the tattoo session. VOW Tattoo Studio reserves the right to refuse copying another artist's original work. Final tattoo placement, size, colour, and design should be confirmed before the tattooing process begins.
            </p>
          </div>

          <div>
            <h2 className="text-olive font-display text-xl mb-2 tracking-tight">Pricing & Payments</h2>
            <p>
              Tattoo prices depend on factors including size, placement, complexity, style, artist, and session duration. The final price may differ from an initial estimate if the design or requirements change. Full payment or the agreed balance must be completed as communicated by the studio.
            </p>
          </div>

          <div>
            <h2 className="text-olive font-display text-xl mb-2 tracking-tight">Cancellation & Rescheduling</h2>
            <p>
              Clients are requested to provide advance notice if they need to cancel or reschedule an appointment. Deposits/booking amounts may be non-refundable or subject to the studio's cancellation policy. Repeated cancellations, late arrivals, or failure to attend an appointment may result in loss of the booking amount.
            </p>
          </div>

          <div>
            <h2 className="text-olive font-display text-xl mb-2 tracking-tight">Client Responsibility</h2>
            <p>
              Clients must inform the studio and artist about any relevant allergies, skin conditions, medications, medical concerns, or other circumstances that may affect tattooing or piercing. The client is responsible for following the aftercare instructions provided by VOW Tattoo Studio.
            </p>
          </div>

          <div>
            <h2 className="text-olive font-display text-xl mb-2 tracking-tight">Aftercare</h2>
            <p>
              Proper aftercare is essential for healing. VOW Tattoo Studio provides aftercare instructions, but healing results may vary depending on individual skin, lifestyle, and adherence to aftercare instructions. VOW Tattoo Studio is not responsible for complications caused by improper aftercare or failure to follow professional instructions.
            </p>
          </div>

          <div>
            <h2 className="text-olive font-display text-xl mb-2 tracking-tight">Right to Refuse Service</h2>
            <p>
              VOW Tattoo Studio reserves the right to refuse tattooing or piercing services where we believe the service may be unsafe, inappropriate, unlawful, or unsuitable for the client.
            </p>
          </div>

          <div>
            <h2 className="text-olive font-display text-xl mb-2 tracking-tight">Website Content</h2>
            <p>
              All photographs, videos, artwork, designs, logos, text, and other content displayed on this website belong to VOW Tattoo Studio or their respective owners and may not be copied, reproduced, or commercially used without permission.
            </p>
          </div>

          <div>
            <h2 className="text-olive font-display text-xl mb-2 tracking-tight">Changes to These Terms</h2>
            <p>
              VOW Tattoo Studio reserves the right to update or modify these Terms & Conditions at any time. Updated terms will be published on this website.
            </p>
          </div>

          <div>
            <h2 className="text-olive font-display text-xl mb-2 tracking-tight">Contact</h2>
            <p>
              For questions regarding these Terms & Conditions, please contact: VOW Tattoo & Piercing Studio, Ramdev Park, Mira road, vowtattoos05@gmail.com, 8850185558.
            </p>
          </div>
        </div>

        <div className="my-16 border-t border-olive/20" />

        <h1 className="font-display text-4xl md:text-5xl font-medium tracking-tighter text-cream mb-12">
          PRIVACY <span className="italic font-light font-shadows text-olive">POLICY</span>
        </h1>

        <div className="space-y-8 text-cream/70 leading-relaxed text-sm md:text-base">
          <p>
            VOW Tattoo & Piercing Studio respects your privacy and is committed to protecting your personal information.
          </p>

          <p>
            When you contact us, book an appointment, submit an enquiry, or interact with our website, we may collect information such as your name, phone number, email address, appointment details, and information necessary to provide our services.
          </p>

          <div>
            <h2 className="text-olive font-display text-xl mb-2 tracking-tight">We use this information to:</h2>
            <ul className="list-disc list-inside space-y-1 pl-4">
              <li>Respond to enquiries</li>
              <li>Schedule and manage appointments</li>
              <li>Communicate regarding bookings</li>
              <li>Provide tattoo and piercing services</li>
              <li>Improve our services and website</li>
              <li>Send relevant updates where permitted</li>
            </ul>
          </div>

          <p>
            We do not sell or rent your personal information to third parties. Payment information, where applicable, may be processed through third-party payment providers and will be subject to their respective privacy policies.
          </p>

          <p>
            We may use photographs or videos of completed tattoos, piercings, or studio work for portfolio and promotional purposes only where appropriate consent has been obtained.
          </p>

          <p>
            You may contact us to request access, correction, or deletion of your personal information, subject to applicable legal requirements.
          </p>
        </div>
      </div>
    </div>
  );
}
